import React, { useContext, useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { BoletimContext } from "../context/BoletimContext";

export default function PwaUpdateNotice() {
  const { flushLocalDraft, pendingCount } = useContext(BoletimContext);
  const [updateReady, setUpdateReady] = useState(false);
  const [applying, setApplying] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const onUpdate = () => setUpdateReady(true);
    const onControllerChange = () => {
      if (applying) window.location.reload();
    };
    window.addEventListener("boonline:pwa-update", onUpdate);
    window.addEventListener("boonline:pwa-controller-change", onControllerChange);
    return () => {
      window.removeEventListener("boonline:pwa-update", onUpdate);
      window.removeEventListener("boonline:pwa-controller-change", onControllerChange);
    };
  }, [applying]);

  const applyUpdate = async () => {
    setApplying(true);
    setError("");
    try {
      await flushLocalDraft();
      const worker = window.__boOnlineSwRegistration?.waiting;
      if (!worker) {
        setApplying(false);
        setUpdateReady(false);
        return;
      }
      worker.postMessage({ type: "SKIP_WAITING" });
    } catch (updateError) {
      setApplying(false);
      setError(updateError.message || "Não foi possível preservar o rascunho antes da atualização.");
    }
  };

  if (!updateReady) return null;
  return (
    <Alert variant="info" className="d-flex align-items-center justify-content-between flex-wrap gap-2 mx-2 mt-2" role="status">
      <span>Há uma atualização do BO Online disponível.{pendingCount ? ` ${pendingCount} rascunho(s) serão preservados antes da atualização.` : ""}{error ? ` ${error}` : ""}</span>
      <Button size="sm" variant="primary" onClick={applyUpdate} disabled={applying}>
        {applying ? <><Spinner size="sm" className="me-2" />Preservando...</> : "Atualizar aplicativo"}
      </Button>
    </Alert>
  );
}
